// this should be used in task assignment dropdowns to indicate to the caller that
// they should clear the task assignment
export const UNASSIGNED_TASK_SENTINEL = '__UNASSIGN_TASKS' as const;
